import request from '@/utils/http';
// 查询列表
export const getSourceRoot = (params) => {
    return request({
        url: `/api-tms/transportChoose/searchListCenter`,
        method: 'post',
        data: params
    }).then(res => res);
};
// 无白名单限制的查询列表
export const getSourceRoot2 = (params) => {
    return request({
        url: `/api-tms/transportChoose/searchListCenter2`,
        method: 'post',
        data: params
    }).then(res => res);
};
// 调度中心（新）获取分组
export const getNewSourceRoot = (params) => {
    return request({
        url: `/api-tms/transportExtend/selectDispatchCentreGroup`,
        method: 'post',
        data: params
    }).then(res => res);
};
// 调度中心（新）获取运单详情
export const getNewSourceData = (params) => {
    return request({
        url: `/api-tms/transport/list/bygrouppolicy`,
        method: 'post',
        data: params
    }).then(res => res);
};
export const getSourceData = (params) => {
    return request({
        url: `/api-tms/transportChoose/searchTransportsByGrouppolicy`,
        method: 'post',
        data: params
    }).then(res => res);
};
export const getDictList = (params) => {
    return request({
        url: `/api-mdm/dictionaryDetail/dict`,
        method: 'get',
        params
    });
};
export const getTargetRoot = (data) => {
    return request({
        url: `/api-tms/dispatch/list`,
        method: 'post',
        data
    }).then(res => res);
};
export const getTargetData = (data) => {
    return request({
        url: `/api-tms/transport/list/sort`,
        method: 'post',
        data
    }).then(res => res);
};
export const getDetailStatistics = (data) => {
    return request({
        url: `/api-tms/transport/itemdeail/count`,
        method: 'post',
        data
    }).then(res => res);
};
export const getStorageData = (params) => {
    return request({
        url: `/api-tms/dispatch/distribution/search`,
        method: 'get',
        params
    }).then(res => res);
};
export const getAllocate = (data) => {
    return request({
        url: `/api-tms/dispatch/distribution/update/${data.taskNo}`,
        method: 'put',
        data
    }).then(res => res);
};
export const getCancleAllocate = (data) => {
    return request({
        url: `/api-tms/dispatch/distribution/cancel`,
        method: 'put',
        data
    }).then(res => res);
};
export const saveCarArrange = (data) => {
    return request({
        url: `/api-tms/dispatch/artificial/save`,
        method: 'post',
        data
    }).then(res => res);
};
export const intelligentDispatch = (data) => {
    return request({
        url: `/api-tms/dispatch/intelligent`,
        method: 'post',
        data
    }).then(res => res);
};
export const updateCarArrange = (data) => {
    return request({
        url: `/api-tms/transport/operate`,
        method: 'post',
        data
    }).then(res => res);
};
export const updateIntelliArrange = (data) => {
    return request({
        url: `/api-tms/intelligent/operate`,
        method: 'post',
        data
    }).then(res => res);
};
export const getTransferData = (data) => {
    return request({
        url: `/api-tms/transport/transfer`,
        method: 'post',
        data
    }).then(res => res);
};
export const getTabelExpandDetail = (data) => {
    return request({
        url: `/api-tms/transport/itemdeail`,
        method: 'post',
        data
    }).then(res => res);
};
// 修改配送方式页面获取网点信息
export const searchNetInfo = (data) => {
    return request({
        url: `/api-tms/transports/searchNetinfo`,
        method: 'post',
        data
    }).then(res => res);
};
// 修改配送方式
export const updateDeliveryMethods = (data) => {
    return request({
        url: `/api-tms/transport/distributionModeUpdate`,
        method: 'post',
        data
    }).then(res => res);
};
// 查询网点信息
export const netInfos = (params) => {
    return request({
        url: `/api-mdm/netInfos`,
        method: 'get',
        params
    });
};
export const issueCarrier = (data) => {
    return request({
        url: `/api-tms/transport/issueCarrier`,
        method: 'put',
        data
    });
};
export const confirmIssueCarrier = (data) => {
    return request({
        url: `/api-tms/transport/confirmIssueCarrier`,
        method: 'put',
        data
    });
};
// 获取筛单规则数据
export const getServeRule = (data) => {
    return request({
        url: `/api-tms/transportChoose/searchList`,
        method: 'post',
        data
    }).then(res => res);
};
// 提交到算法排车数据
export const algorithmLine = (data) => {
    return request({
        url: `/api-tms/algorithm/line/execute`,
        method: 'post',
        data
    }).then(res => res);
};
// 提交到算法排车和重算混合接口
export const recombineAlgorithmLine = (data) => {
    return request({
        url: `/api-tms/algorithmLine/recombine`,
        method: 'post',
        data
    }).then(res => res);
};

// 查询车次信息
export const getCarListApi = (data) => {
    return request({
        url: `/api-tms/lineHeader/userLastOperate/query`,
        method: 'post',
        data
    }).then(res => res);
};

// 算法作废, 批量作废接口
export const cancelApi = (params) => {
    return request({
        'url': '/api-tms/lineDetail/cancel',
        method: 'post',
        data: params
    });
};
// 算法行排车接口
export const dispatchSave = (params) => {
    return request({
        url: '/api-tms/dispatch/algorithm/save',
        method: 'post',
        data: params
    });
};
// 网络调车验证是否需要获取授权
export const checkLogin = (data) => {
    return request({
        url: '/api-tms/mb/checkLogin',
        method: 'post',
        data
    });
};
// 预约日期
export const updateLspAppointmentTimeApi = (data) => {
    return request({
        url: `/api-tms/dispatch/updateLspAppointmentTime`,
        method: 'post',
        data
    })
};
// 整车排车时提示在途跟踪方式
export const promptTrackType = (data) => {
    return request({
        url: `/api-tms/dispatch/promptTrackType?dispatchNo=${data}`,
        method: 'post'
    });
};
// 白名单接口
export const getWhiteListApi = (params) => {
    return request({
        url: `/api-opms/opms/whitelist/list`,
        method: 'get',
        params
    });
};
